var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('tg-app-bar'),_c('v-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }